import { RxComponent } from 'app/core/components/common/rx.component';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { SessionService } from 'app/core/services/session.service';

import { OrganizationDetailsService } from '../organization-details.service';
import { NotificationService } from '../../../../core/services/notification.service';
import { ConfigService } from '../../../../core/services/config.service';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { SmartModalService, ModalSize } from 'app/core/services/smart-modal.service';

import { AddressEditComponent } from './address/address-edit/address-edit.component';
import { AddressAddComponent } from './address/address-add/address-add.component';
import { AddressesManageGridComponent } from './address/addresses-manage-grid/addresses-manage-grid.component';

import { AddDomainComponent } from './add-domain/add-domain.component';
import { EnvironmentService } from 'app/core/services/environment.service';
import { UtilService } from 'app/core/services/util.service';

declare var $: any;

@Component({
    selector: 'itpx-organization-details-edit',
    templateUrl: './organization-details-edit.component.html',
    styleUrls: ['./organization-details-edit.component.css']
})
export class OrganizationDetailsEditComponent extends RxComponent {

    private details: any;
    private domainDetails: any;
    private formattDetails: any;
    private sub: Subscription;
    private saveUrl: string;
    private cancelRoute: string
    private fields: any[];
    private id: string;
    private addresses: any;
    private isUserAdmin: boolean = false;
    private userGroups: any;

    private billingFields: Array<any>;
    private sellerAccountFields: Array<any>;

    private backRoute: string;

    private unsavedChangesOnTab: boolean = false;

    addressForm: FormGroup;
    isAccountSeller: boolean = false;
    isSeller: boolean = false;

    isFSPEnv: boolean;

    constructor(
        private service: OrganizationDetailsService,
        private configService: ConfigService,
        private notificationService: NotificationService,
        private router: Router,
        private route: ActivatedRoute,
        private fb: FormBuilder,
        private smartModalService: SmartModalService,
        private sessionService: SessionService,
        private environmentService: EnvironmentService,
        private utilService: UtilService,
    ) {
        super();
    }

    ngOnInit() {

        this.isFSPEnv = this.environmentService.isFSPEnv;

        this.cancelRoute = this.router.url
        this.billingFields = this.service.getBillingEditFields();
        this.sellerAccountFields = this.service.getSellerAccountEditFields();

        this.addressForm = this.fb.group({
            defaultShippingAddress: ['']
        });

        this.service.getDomainDetails()
            .bindToLifecycle(this)
            .subscribe(
                body => {
                    this.domainDetails = body.data;
                    this.service.getAddresses(this.domainDetails.name)
                        .bindToLifecycle(this)
                        .subscribe(
                            body => {
                                this.addresses = body.data;
                            }
                        )
                }
            );

        this.sub = this.route.params.subscribe(params => {
            this.id = params['id'];
            this.fields = this.service.getOverviewEditFields();
            this.service.getDetails(this.id)
                .subscribe(
                    body => {
                        let results = Object.assign({}, body.data);
                        this.details = <any>body['data'];
                        this.isAccountSeller = this.details.sellerAccount ? true : false;
                        this.isSeller = body.data.seller;
                        this.addCountryOriginAndWebsiteContactInFields();
                        this.formattDetails = {
                            currency: results.currency ? results.currency.configValue : null,
                            paymentTerm: results.paymentTerm ? results.paymentTerm.configValue : null,
                            creditLimit: results.creditLimitAmount ? (results.creditLimitCurrency + ' ' + results.creditLimitAmount) : '',
                            duns: results.duns,
                            vatNumber: results.vatNumber,
                            defaultBillToAddressEmail: results.defaultBillToAddress ? results.defaultBillToAddress.email : null,
                            dunningEmail: results.dunningEmail,
                            defaultShipToAddressID: results.defaultShipToAddress ? results.defaultShipToAddress.id : null,
                            defaultBillToAddress: results.defaultBillToAddress ? this.service.getFormattedAddress(results.defaultBillToAddress) : '',
                        };

                        this.addressForm.patchValue({
                            defaultShippingAddress: results.defaultShipToAddress ? results.defaultShipToAddress.id : null
                        });

                        this.onTabLoading()
                    }
                );
        });

        this.userGroups = this.sessionService.getUserGroups();

        if (this.service.isUserAdmin()) {
            this.isUserAdmin = true;
        } else {
            this.router.navigate(['/not-found']);
        }

        this.saveUrl = this.configService.get('server').url + this.configService.get('endpoints').organization.organizationDetails.edit.api;

        $('.nav-tabs a[data-toggle=tab]').on('click', function (e) {
            if ($(this).hasClass('disabled-tab')) {
                $('.nav-tabs a[data-toggle=tab]').removeAttr('href');
                $('.nav-tabs .dropdown-item').removeAttr('href');
                e.preventDefault();
                return false;
            }
        });
        $('.nav-tabs a[data-toggle=dropdown]').on('click', function (e) {
            if ($(this).hasClass('disabled-tab')) {
                $('.nav-tabs a[data-toggle=dropdown]').removeAttr('href');
                $('.nav-tabs .dropdown-item').removeAttr('href');
                e.preventDefault();
                return false;
            }
        });

        this.addressForm.valueChanges
            .skip(1)
            .subscribe(() => {
                if (this.addressForm.dirty) {
                    this.disableTabs();
                }
            });
    }

    ngAfterViewInit() {
        $('#seller-info-tab').on('click', function (e) {
            if ($(this).hasClass('disabled-tab')) {
                $('.nav-tabs a[data-toggle=tab]').removeAttr('href');
                $('.nav-tabs .dropdown-item').removeAttr('href');
                e.preventDefault();
                return false;
            }
        });
    }

    private onTabLoading() {
        this.route.queryParams
            .map(params => params['tab'])
            .filter(tab => tab)
            .bindToLifecycle(this)
            .subscribe(tab => {
                setTimeout(() => $(`.nav-tabs a[href="#${tab}"]`).tab('show'), 500)
            });
    }
    private addCountryOriginAndWebsiteContactInFields() {
        if (this.isSeller && this.isFSPEnv) {
            let extraFields = [{
                key: 'countryOfOrigin',
                label: 'Country of Origin',
                type: 'dropdown',
                required: true,
                dictionaryUrl: this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.country.api
            },
            {
                key: 'companyWebsiteContact',
                label: 'Company Website (Contact Us Page)',
                type: 'textbox',
                required: true,
                pattern:'url'
            }];
            this.fields = [...this.fields, ...extraFields];
        }
    }
    private onSaveAccountInfo(details: any) {
        const checkSellerFields = (this.isSeller && this.isFSPEnv);
        if (details.website && details.companyWebsiteContact && checkSellerFields &&
            this.utilService.remove_http(details.website.trim()) === this.utilService.remove_http(details.companyWebsiteContact.trim())) {
            this.notificationService.error('Please enter website URL which has contact us page', 'Error')
        } else {

            this.enableTabs();
            delete this.details['domains'];
            this.details['name'] = details.name;
            this.details['watermark'] = details.watermark
            this.details['website'] = details.website;
            this.details['email'] = details.email;
            this.details['additionalName'] = details.additionalName;
            if (checkSellerFields) {
                this.details['countryOfOrigin'] = details.countryOfOrigin;
                this.details['companyWebsiteContact'] = details.companyWebsiteContact;
            }
            this.editAccountInfo(this.details);
        }
    }

    private onSaveBillingInfo(details: any) {
        this.enableTabs();
        delete this.details['domains'];
        this.details['defaultBillToAddress']['email'] = details.defaultBillToAddressEmail;
        this.details['dunningEmail'] = details.dunningEmail;
        this.editBillingInfo(this.details)
    }

    private onSaveSellerAccount(details: any) {
        this.enableTabs();
        delete this.details['domains'];
        this.details['sellerAccount']['aboutSeller'] = details.aboutSeller;
        this.details['sellerAccount']['supportEmail'] = details.supportEmail;
        this.details['sellerAccount']['examFulfilmentEmail'] = details.examFulfilmentEmail;
        this.details['sellerAccount']['serviceDeliveryEmail'] = details.serviceDeliveryEmail;
        this.details['sellerAccount']['manualDeliveryEmail'] = details.manualDeliveryEmail;
        if (this.isFSPEnv) {
            this.details['sellerAccount']['gstRegistrationNumber'] = details.gstRegistrationNumber.toUpperCase();
            this.details['sellerAccount']['panNumber'] = details.panNumber.toUpperCase();
            this.details['sellerAccount']['signatureKey'] = details.signatureKey;
            this.details['sellerAccount']['signatureBucket'] = details.signatureBucket;
            this.details['sellerAccount']['signatureURL'] = this.configService.getSphinxUrlUnsecured('phoenix-v2', details.signatureBucket, details.signatureKey);
        }
        this.editSellerInfo(this.details)
    }

    private onSaveShippingAddress() {
        let details = Object.assign({}, this.details);
        details['defaultShipToAddress'] = { id: this.addressForm.controls.defaultShippingAddress.value };
        this.service.editAddresses(details)
            .subscribe(
                data => {
                    this.router.navigate(['/organization/organization-details'], { queryParams: { tab: 'addresses' } })
                }
            )
    };

    private edit(account: any) {
        this.service.edit(account)
            .subscribe(body => {
                this.router.navigate(['/organization/organization-details'], { queryParams: { tab: 'branded' } });
            });
    }

    private editAccountInfo(accountInfo: any) {
        this.service.editAccountInfo(accountInfo)
            .subscribe(body => {
                this.router.navigate(['/organization/organization-details']);
            });
    }
    private editBillingInfo(billingInfo: any) {
        this.service.editBillingInfo(billingInfo)
            .subscribe(body => {
                this.router.navigate(['/organization/organization-details'], { queryParams: { tab: 'billingInfo' } });
            });
    }
    private editSellerInfo(sellerInfo: any) {
        this.service.editSellerInfo(sellerInfo)
            .subscribe(body => {
                this.router.navigate(['/organization/organization-details'], { queryParams: { tab: 'sellerAccount' } });
            });
    }

    private onTabClick(e) {
        if (e.srcElement.className.indexOf('disabled-tab') != -1) {
            $('.nav-tabs .dropdown-item').removeAttr('href');
            $('.nav-tabs a[data-toggle=tab]').removeAttr('href');
            $('.nav-tabs a[data-toggle=tab]').removeAttr('data-toggle');
            $('.nav-tabs a[data-toggle=dropdown]').removeAttr('data-toggle');
            e.preventDefault();
            return false;
        } else {
            let tabId = e.srcElement.attributes['href'].value;
            this.router.navigate(
                ['/organization/organization-details', this.id, 'edit'],
                { queryParams: { tab: tabId.substr(1) } }
            );
        }

    }

    private openModal(action: string) {
        let component;
        let details;
        let message;
        let classModal;

        if (action === 'editBillingAddress') {
            component = AddressEditComponent;
            details = Object.assign({}, this.details.defaultBillToAddress);
            details['isDefaultBillingAddress'] = true;
            message = 'Edit Billing Address'
        } else if (action === 'addNewAddress') {
            component = AddressAddComponent;
            details = { domain: this.details.domains[0].name };
            message = 'Add New Address'
        } else if (action === 'manageAddresses') {
            component = AddressesManageGridComponent;
            details = this.details;
            message = 'Manage Addresses';
            classModal = ModalSize.Lg;
        } else if (action === 'addDomain') {
            component = AddDomainComponent;
            details = {};
            message = 'Add Domain Name'
        }

        this.smartModalService.open(component, details, message, classModal)
            // .neverError()
            .bindToLifecycle(this)
            .subscribe(
                data => {
                    if (data.result == 'success') {
                        this.fetchDetails();
                    }

                },
                error => {
                    this.fetchDetails();
                }
            )
    }
    private fetchDetails() {

        this.sub = this.route.params.subscribe(params => {
            this.id = params['id'];
            this.fields = this.service.getOverviewEditFields();
            this.service.getDetails(this.id)
                .subscribe(
                    body => {
                        let results = Object.assign({}, body.data);
                        this.details = <any>body['data'];

                        this.formattDetails = {
                            currency: results.currency.configValue,
                            paymentTerm: results.paymentTerm.configValue,
                            creditLimit: results.creditLimitAmount ? (results.creditLimitCurrency + ' ' + results.creditLimitAmount) : '',
                            duns: results.duns,
                            vatNumber: results.vatNumber,
                            defaultBillToAddressEmail: results.defaultBillToAddress.email,
                            dunningEmail: results.dunningEmail,
                            defaultShipToAddressID: results.defaultShipToAddress.id,
                            defaultBillToAddress: results.defaultBillToAddress ? this.service.getFormattedAddress(results.defaultBillToAddress) : '',
                        }

                        this.addressForm.patchValue({
                            defaultShippingAddress: results.defaultShipToAddress.id
                        })
                    }
                );

        });

        this.service.getDomainDetails()
            .bindToLifecycle(this)
            .subscribe(
                body => {
                    this.domainDetails = body.data;
                    this.service.getAddresses(this.domainDetails.name)
                        .bindToLifecycle(this)
                        .subscribe(
                            body => {
                                this.addresses = body.data;
                            }
                        )
                }
            )
    }

    private makeDefault(domainNameId: string) {
        this.service.makeDomainNameDefault(domainNameId)
            .subscribe(
                data => this.fetchDetails()
            );
    }

    private onCancel() {
        let tab = this.route.snapshot.queryParams['tab'];
        this.router.navigate(
            ['/organization/organization-details'],
            tab ? { queryParams: { tab: tab } } : {}
        );
    }

    private unsavedChanges() {
        this.unsavedChangesOnTab = true;
        this.disableTabs();
    };

    private disableTabs() {
        $('.nav-tabs li:not(.active) a[data-toggle=tab]').addClass('disabled-tab');
        $('.nav-tabs li:not(.active) a[data-toggle=dropdown]').addClass('disabled-tab');
        $('.nav-tabs .dropdown-item').addClass('disabled-tab');
    }

    private enableTabs() {
        this.unsavedChangesOnTab = false;
        $('.nav-tabs li:not(.active) a[data-toggle=tab]').removeClass('disabled-tab');
        $('.nav-tabs li:not(.active) a[data-toggle=dropdown]').removeClass('disabled-tab');
        $('.nav-tabs li:not(.active) .dropdown-item').remove('disabled-tab');
    }

}



// WEBPACK FOOTER //
// ./src/app/organization/components/organization-details/organization-details-edit/organization-details-edit.component.ts